import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "../rootReducer";

interface NavigationState {
    activeId: string,
    isLoadingFinished: boolean
    hasError: boolean
    wasTriggeredByClick: boolean,
    isScrollDetectionBlocked: boolean,
}

const initialState: NavigationState = {
    activeId: '#person-name',
    isLoadingFinished: false,
    hasError: false,
    wasTriggeredByClick: false,
    isScrollDetectionBlocked: false,
}
const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setIsLoadingFinished(state, { payload = true }: PayloadAction<boolean>) {
            state.isLoadingFinished = payload;
            state.hasError = false;
        },
        setHasError(state, { payload = true }: PayloadAction<boolean>) {
            state.hasError = payload;
        },
        setActiveId: (state, { payload }: PayloadAction<string>) => {
            state.activeId = payload
        },
        setActiveIdByClick(state, { payload }: PayloadAction<string>) {
            state.activeId = payload;
            state.wasTriggeredByClick = true;
            state.isScrollDetectionBlocked = true;
        },
        unblockScrollDetection(state) {
            state.isScrollDetectionBlocked = false;
        }
    }
})

export const getActiveIdSelector = (state: RootState) => state.mainNavigation.activeId;
export const getIsScrollDetectionBlocked = (state: RootState) => state.mainNavigation.isScrollDetectionBlocked;
export const getIsLoadingFinished = (state: RootState) => state.mainNavigation.isLoadingFinished;
export const getHasNoError = (state: RootState) => state.mainNavigation.hasError === false;

export const {
    setActiveId,
    unblockScrollDetection,
    setActiveIdByClick,
    setIsLoadingFinished,
    setHasError
} = navigationSlice.actions

export default navigationSlice.reducer;